// core/theme.ts — Platik-IA
// Tema claro / oscuro / sistema. Resuelve el tema en JS y lo aplica como
// `data-theme` en <html>; los tokens (tokens.css) responden a ese atributo.
// Preferencia por dispositivo (localStorage), no se sincroniza a Supabase.

export type ThemePref = 'light' | 'dark' | 'system';

const KEY = 'platik:theme';
const lightMq = () => window.matchMedia('(prefers-color-scheme: light)');

/** Preferencia guardada (default 'system'). */
export function getThemePref(): ThemePref {
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}

function resolve(pref: ThemePref): 'light' | 'dark' {
  if (pref === 'system') return lightMq().matches ? 'light' : 'dark';
  return pref;
}

// Color de la barra de estado móvil (no puede ser var(); = brand-neutral-900/50).
function setMetaThemeColor(theme: 'light' | 'dark'): void {
  const color = theme === 'light' ? '#f8fafc' : '#0f172a';
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]:not([media])');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.content = color;
}

/** Aplica el tema efectivo a <html data-theme> y a la barra de estado. */
export function applyTheme(pref: ThemePref = getThemePref()): void {
  const theme = resolve(pref);
  document.documentElement.dataset.theme = theme;
  setMetaThemeColor(theme);
}

/** Guarda la preferencia y la aplica. */
export function setThemePref(pref: ThemePref): void {
  if (pref === 'system') localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, pref);
  applyTheme(pref);
}

/** Aplica al arrancar y, si está en 'system', sigue los cambios del SO en vivo. */
export function initTheme(): void {
  applyTheme();
  lightMq().addEventListener('change', () => {
    if (getThemePref() === 'system') applyTheme('system');
  });
}
